import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '@/lib/api';

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!sessionId) {
      setStatus('unknown');
      return;
    }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setStatus('paid');
          return;
        }
        if (tries < 10) {
          tries += 1;
          setTimeout(poll, 2000);
        } else {
          setStatus('pending');
        }
      } catch {
        setStatus('unknown');
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-yunti-ground flex items-center justify-center px-6" data-testid="payment-success">
      <div className="max-w-md text-center space-y-6">
        <span className="text-xs font-mono uppercase tracking-[0.25em] text-yunti-green font-semibold">YUNTI</span>
        <h1 className="text-4xl font-display uppercase tracking-tight text-yunti-ink">
          {status === 'paid' ? 'Order confirmed' : status === 'checking' ? 'Confirming…' : 'Almost there'}
        </h1>
        <p className="text-sm text-yunti-ink/70">
          {status === 'paid'
            ? 'Thank you. Your payment went through — a confirmation is on its way.'
            : 'We are confirming your payment with Stripe. This page updates automatically.'}
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-4 bg-yunti-ink text-white text-xs font-mono uppercase tracking-[0.2em] hover:bg-yunti-purple transition-colors"
          data-testid="back-to-site"
        >
          Back to YUNTI
        </Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-yunti-ground flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="max-w-md text-center space-y-6">
        <span className="text-xs font-mono uppercase tracking-[0.25em] text-yunti-purple font-semibold">YUNTI</span>
        <h1 className="text-4xl font-display uppercase tracking-tight text-yunti-ink">Checkout cancelled</h1>
        <p className="text-sm text-yunti-ink/70">No payment was taken. Your cart is still there if you change your mind.</p>
        <Link
          to="/"
          className="inline-block px-8 py-4 bg-yunti-ink text-white text-xs font-mono uppercase tracking-[0.2em] hover:bg-yunti-purple transition-colors"
          data-testid="back-to-site"
        >
          Back to YUNTI
        </Link>
      </div>
    </div>
  );
}
